import { Document, Image, Page, Text, View } from "@react-pdf/renderer";
import email from "../../../assets/icons/email.png";
import location from "../../../assets/icons/location.png";
import call from "../../../assets/icons/phone.png";
import Logo from "../../../assets/image/logo512.png";
import {
  formatIndianCurrency,
  formatToDDMMYYYY,
  toCapitaliseStringType1,
} from "../../../utils/common";
import { reportStyles } from "../../custom-report/report-style";
import dayjs from "dayjs";

const EmployeeExportPDF = ({
  employeeExportData,
  branchList,
  organizationInfoEmpExport: orgInfo,
}) => {
  return (
    <Document>
      <Page size="A4" orientation="landscape" style={reportStyles.page}>
        {/* Static-Header */}
        <View fixed>
          <View style={reportStyles.pdfHeader}>
            <View style={reportStyles.PdfLogo}>
              <Image
                src={
                  orgInfo?.logo
                    ? `data:image/png;base64,${orgInfo?.base64logo}`
                    : Logo
                }
                alt="Logo"
                style={reportStyles.Logo}
              />
            </View>

            <View style={reportStyles.HeaderDescription}>
              {orgInfo?.org_name && (
                <Text style={reportStyles.HeaderHeading}>
                  {orgInfo?.org_name}
                </Text>
              )}
              {(orgInfo?.address ||
                orgInfo?.locality ||
                orgInfo?.landmark ||
                orgInfo?.city ||
                orgInfo?.state ||
                orgInfo?.country ||
                orgInfo?.pincode) && (
                <View
                  style={[
                    reportStyles.HeaderLocation,
                    { marginBottom: "10px" },
                  ]}
                >
                  <Image
                    src={location}
                    alt="location"
                    style={{
                      width: "12px",
                      height: "auto",
                      objectFit: "contain",
                    }}
                  />
                  <Text>
                    {orgInfo?.address ? orgInfo.address + ", " : ""}
                    {orgInfo?.locality ? orgInfo.locality + ", " : ""}
                    {orgInfo?.landmark ? orgInfo.landmark + ", " : ""}
                    {orgInfo?.city ? orgInfo.city + ", " : ""}
                    {orgInfo?.state ? orgInfo.state + ", " : ""}
                    {orgInfo?.country ? orgInfo.country + " " : ""}
                    {orgInfo?.pincode ? orgInfo.pincode : ""}
                  </Text>
                </View>
              )}

              <View style={reportStyles.HeaderLocation}>
                {/* Phone Number */}
                {(orgInfo?.phone || orgInfo?.landline) && (
                  <View
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "5px",
                      flexDirection: "row",
                    }}
                  >
                    <Image
                      src={call}
                      alt="call"
                      style={{
                        width: "12px",
                        height: "auto",
                        objectFit: "contain",
                      }}
                    />
                    <Text>{orgInfo?.phone || orgInfo?.landline}</Text>
                  </View>
                )}

                {/* Email Address */}
                {orgInfo?.email && (
                  <View
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "5px",
                      flexDirection: "row",
                    }}
                  >
                    <Image
                      src={email}
                      alt="email"
                      style={{
                        width: "12px",
                        height: "auto",
                        objectFit: "contain",
                      }}
                    />
                    <Text>{orgInfo?.email}</Text>
                  </View>
                )}
              </View>
            </View>
          </View>
          <View style={reportStyles.gap} />
        </View>
        <View style={reportStyles.pdfHeaderTableHeadingwrapper}>
          <View>
            <Text style={reportStyles.pdfHeaderTableHeading}>
              {/* EPF Report of February, 2024 (Form - B) */}
              Employee List
              {/* EPF Report (Form - B) */}
            </Text>
          </View>
          <View>
            <Text style={reportStyles.pdfHeaderTableHeading}>
              {/* Employee Code: TSPL021 */}
            </Text>
          </View>
        </View>
        {/* Static-Header */}

        {/* <Text style={reportStyles.pdfHeaderTableHeading}>
          Employee Details of March 2025
        </Text> */}
        {/* <View style={reportStyles.pdfHeaderTable}>
          <View style={reportStyles.pdfHeaderBox}>
            <Text>Total Employee:</Text>
            <Text>100</Text>
          </View>

          <View style={reportStyles.pdfHeaderBox}>
            <Text>Salaried Employee:</Text>
            <Text>80</Text>
          </View>

          <View style={reportStyles.pdfHeaderBox}>
            <Text>New Joining:</Text>
            <Text>5</Text>
          </View>

          <View style={reportStyles.pdfHeaderBox}>
            <Text>Left In Service:</Text>
            <Text>2</Text>
          </View>

          <View style={reportStyles.pdfHeaderBox}>
            <Text>Employee On Leave:</Text>
            <Text>3</Text>
          </View>

          <View style={reportStyles.pdfHeaderBox}>
            <Text>ESI Member:</Text>
            <Text>60</Text>
          </View>

          <View style={reportStyles.pdfHeaderBox}>
            <Text>Employee Under P-Tax :</Text>
            <Text>50</Text>
          </View>

          <View style={reportStyles.pdfHeaderBox}>
            <Text>Total Male Employee</Text>
            <Text>25</Text>
          </View>

          <View style={reportStyles.pdfHeaderBox}>
            <Text>EPF Cover Wages:</Text>
            <Text>₹400000.00</Text>
          </View>
          <View style={reportStyles.pdfHeaderBox}>
            <Text>Total Female Employee:</Text>
            <Text>15</Text>
          </View>

          <View style={reportStyles.pdfHeaderBox}>
            <Text>P-Tax Amount:</Text>
            <Text>₹5000.00</Text>
          </View>

          <View style={reportStyles.pdfHeaderBox}>
            <Text>Others Employee:</Text>
            <Text>4</Text>
          </View>
        </View> */}

        {/* start here  */}

        <View style={reportStyles.ReportTable}>
          <View style={reportStyles.ReportTh} fixed>
            <Text
              style={[
                reportStyles.ReportHeaderCell,
                {
                  width: "2%",
                  borderRight: "  0.5px solid #ccc",
                  textAlign: "center",
                },
              ]}
            >
              SL
            </Text>
            <Text
              style={[
                reportStyles.ReportHeaderCell,
                {
                  width: "5%",
                  borderRight: "  0.5px solid #ccc",
                  textAlign: "center",
                },
              ]}
            >
              E-CODE
            </Text>
            <Text
              style={[
                reportStyles.ReportHeaderCell,

                {
                  width: "15%",
                  textAlign: "left",
                  borderRight: "  0.5px solid #ccc",
                },
              ]}
            >
              NAME
            </Text>
            <Text
              style={[
                reportStyles.ReportHeaderCell,
                {
                  width: "7%",
                  textAlign: "center",
                  borderRight: "  0.5px solid #ccc",
                },
              ]}
            >
              Phone No
            </Text>
            {/* <Text
              style={[
                reportStyles.ReportHeaderCell,
                {
                  width: "7%",
                  textAlign: "center",
                  borderRight: "  0.5px solid #ccc",
                },
              ]}
            >
              Email Id
            </Text> */}
            <Text
              style={[
                reportStyles.ReportHeaderCell,
                {
                  width: "5%",
                  borderRight: "  0.5px solid #ccc",
                },
              ]}
            >
              Gender
            </Text>
            <Text
              style={[
                reportStyles.ReportHeaderCell,
                {
                  width: "5%",
                  textAlign: "center",
                  borderRight: "  0.5px solid #ccc",
                },
              ]}
            >
              DOB
            </Text>
            <Text
              style={[
                reportStyles.ReportHeaderCell,
                {
                  width: "5%",
                  textAlign: "center",
                  borderRight: "  0.5px solid #ccc",
                },
              ]}
            >
              DOJ
            </Text>

            <Text
              style={[
                reportStyles.ReportHeaderCell,
                {
                  width: "7%",
                  textAlign: "left",
                  borderRight: "  0.5px solid #ccc",
                },
              ]}
            >
              Designation
            </Text>
            <Text
              style={[
                reportStyles.ReportHeaderCell,
                {
                  width: "7%",
                  textAlign: "left",
                  borderRight: "  0.5px solid #ccc",
                },
              ]}
            >
              Department
            </Text>
    

            {/* <Text
              style={[
                reportStyles.ReportHeaderCell,
                {
                  width: "5%",
                  textAlign: "center",
                  borderRight: "  0.5px solid #ccc",
                },
              ]}
            >
              Qualification
            </Text> */}
            <Text
              style={[
                reportStyles.ReportHeaderCell,
                {
                  width: "10%",
                  textAlign: "left",
                  borderRight: "  0.5px solid #ccc",
                },
              ]}
            >
              Branch
            </Text>
            <Text
              style={[
                reportStyles.ReportHeaderCell,
                {
                  width: "10%",
                  textAlign: "left",
                  borderRight: "  0.5px solid #ccc",
                },
              ]}
            >
              Guardian Name
            </Text>
            {/* <Text
              style={[
                reportStyles.ReportHeaderCell,
                {
                  width: "5%",
                  borderRight: "  0.5px solid #ccc",
                },
              ]}
            >
              EMP Status
            </Text> */}

            {/*             
            <Text
              style={[
                reportStyles.ReportHeaderCell,
                {
                  width: "5%",
                  textAlign: "center",
                  borderRight: "  0.5px solid #ccc",
                },
              ]}
            >
              Address
            </Text> */}

            <Text
              style={[
                reportStyles.ReportHeaderCell,
                {
                  width: "5%",
                  borderRight: "  0.5px solid #ccc",
                },
              ]}
            >
              Salary Type
            </Text>
            <Text
              style={[
                reportStyles.ReportHeaderCell,
                {
                  width: "7%",
                  textAlign: "center",
                  borderRight: "  0.5px solid #ccc",
                },
              ]}
            >
              ESI No
            </Text>

            <Text
              style={[
                reportStyles.ReportHeaderCell,
                {
                  width: "7%",
                  textAlign: "center",
                  borderRight: "  0.5px solid #ccc",
                },
              ]}
            >
              UAN
            </Text>

            {/* <Text
              style={[
                reportStyles.ReportHeaderCell,
                {
                  width: "5%",
                  textAlign: "center",
                  borderRight: "  0.5px solid #ccc",
                },
              ]}
            >
              CTC
            </Text> */}
           

            <Text
              style={[
                reportStyles.ReportHeaderCell,
                {
                  width: "7%",
                  textAlign: "right",
                },
              ]}
            >
              Gross
            </Text>
            <Text
              style={[
                reportStyles.ReportHeaderCell,
                {
                  width: "4%",
                  textAlign: "right",
                  borderRight: "  0.5px solid #ccc",
                },
              ]}
            >
              OT RATE
            </Text>

            {/* <Text
              style={[
                reportStyles.ReportHeaderCell,
                {
                  width: "5%",
                  textAlign: "center",
                  borderRight: "  0.5px solid #ccc",
                },
              ]}
            >
              Basic
            </Text> */}

            {/* <Text
              style={[
                reportStyles.ReportHeaderCell,
                {
                  width: "5%",
                  textAlign: "center",
                },
              ]}
            >
              Allowance
            </Text> */}
          </View>
          {employeeExportData.map((data, index) => (
            <>
              <View style={reportStyles.ReportTd} wrap={false}>
                <View
                  style={[
                    reportStyles.ReportTdCell,
                    {
                      width: "2%",
                      borderRight: "  0.5px solid #ccc",
                      textAlign: "center",
                    },
                  ]}
                >
                  <Text>{index + 1}</Text>
                </View>
                <View
                  style={[
                    reportStyles.ReportTdCell,
                    {
                      width: "5%",
                      borderRight: "  0.5px solid #ccc",
                      textAlign: "center",
                    },
                  ]}
                >
                  <Text>
                    {data?.employee_code ? data?.employee_code : "--"}
                  </Text>
                </View>
                <View
                  style={[
                    reportStyles.ReportTdCell,
                    {
                      width: "15%",
                      borderRight: "  0.5px solid #ccc",
                    },
                  ]}
                >
                  <Text>
                    {data?.first_name && data?.last_name
                      ? `${data.first_name} ${data.last_name}`
                      : "--"}
                  </Text>
                </View>
                <View
                  style={[
                    reportStyles.ReportTdCell,
                    {
                      width: "7%",
                      textAlign: "center",
                      borderRight: "  0.5px solid #ccc",
                    },
                  ]}
                >
                  <Text>{data?.phone ? data?.phone : "--"}</Text>
                </View>
                <View
                  style={[
                    reportStyles.ReportTdCell,
                    {
                      width: "5%",
                      textAlign: "center",
                      borderRight: "  0.5px solid #ccc",
                    },
                  ]}
                >
                  <Text> {data?.gender ? data?.gender : "--"}</Text>
                </View>
                {/* <View
                  style={[
                    reportStyles.ReportTdCell,
                    {
                      width: "7%",
                      textAlign: "center",
                      borderRight: "  0.5px solid #ccc",
                    },
                  ]}
                >
                  <Text>{data?.email ? data?.email : "--"}</Text>
                </View> */}
                <View
                  style={[
                    reportStyles.ReportTdCell,
                    {
                      width: "5%",
                      textAlign: "center",
                      borderRight: "  0.5px solid #ccc",
                    },
                  ]}
                >
                  <Text>
                    {data?.date_of_birth
                      ? formatToDDMMYYYY(new Date(data?.date_of_birth))
                      : "--"}
                  </Text>
                </View>
                <View
                  style={[
                    reportStyles.ReportTdCell,
                    {
                      width: "5%",
                      textAlign: "center",
                      borderRight: "  0.5px solid #ccc",
                    },
                  ]}
                >
                  <Text>
                    {data?.join_date
                      ? formatToDDMMYYYY(new Date(data?.join_date))
                      : "--"}
                  </Text>
                </View>

                <View
                  style={[
                    reportStyles.ReportTdCell,
                    {
                      width: "7%",
                      borderRight: "  0.5px solid #ccc",
                    },
                  ]}
                >
                  <Text>
                    {" "}
                    {data?.designation?.designation_name
                      ? data?.designation?.designation_name
                      : "--"}
                  </Text>
                </View>

                <View
                  style={[
                    reportStyles.ReportTdCell,
                    {
                      width: "7%",
                      borderRight: "  0.5px solid #ccc",
                    },
                  ]}
                >
                  <Text>
                    {" "}
                    {data?.department?.dept_name
                      ? data?.department?.dept_name
                      : "--"}
                  </Text>
                </View>
            
                <View
                  style={[
                    reportStyles.ReportTdCell,
                    {
                      width: "10%",
                      borderRight: "  0.5px solid #ccc",
                    },
                  ]}
                >
                  <Text>
                    {data?.branch_id
                      ? toCapitaliseStringType1(
                          branchList?.find((it) => it?.id === data?.branch_id)
                            ?.name || "--"
                        )
                      : "--"}
                  </Text>
                </View>
                {/* <View
                  style={[
                    reportStyles.ReportTdCell,
                    {
                      width: "5%",
                      textAlign: "center",
                      borderRight: "  0.5px solid #ccc",
                    },
                  ]}
                >

                  <Text>{data?.present_address ? data?.present_address : '--'}</Text>
                </View> */}
                {/* <View
                  style={[
                    reportStyles.ReportTdCell,
                    {
                      width: "5%",
                      textAlign: "center",
                      borderRight: "  0.5px solid #ccc",
                    },
                  ]}
                >
                  <Text>----</Text>
                </View> */}
                <View
                  style={[
                    reportStyles.ReportTdCell,
                    {
                      width: "10%",
                      textAlign: "center",
                      borderRight: "  0.5px solid #ccc",
                    },
                  ]}
                >
                  <Text>
                    {data?.guardian_name ? data?.guardian_name : "--"}
                  </Text>
                </View>
                {/* <View
                  style={[
                    reportStyles.ReportTdCell,
                    {
                      width: "5%",
                      borderRight: "  0.5px solid #ccc",
                    },
                  ]}
                >
                  {data?.settlement_date ? "resign"
                    : data?.employment_type === "full_time"
                      ? "permanent"
                      : data?.employment_type === "probationary"
                        ? "Probationary"
                        : data?.employment_type === "contractual"
                          ? "contractual" : "--"}
                </View> */}

                <View
                  style={[
                    reportStyles.ReportTdCell,
                    {
                      width: "5%",
                      textAlign: "center",
                      borderRight: "  0.5px solid #ccc",
                    },
                  ]}
                >
                  <Text>{data?.salary_type ? data?.salary_type.toUpperCase() : "--"}</Text>
                </View>
                <View
                  style={[
                    reportStyles.ReportTdCell,
                    {
                      width: "7%",
                      textAlign: "center",
                      borderRight: "  0.5px solid #ccc",
                    },
                  ]}
                >
                  <Text
                    style={[
                    
                      {
                        width: "100%",
                        wordBreak: "break-word",
                        whiteSpace: "normal",
                        overflowWrap: "break-word",
                        flexWrap: "wrap",
                        textAlign: "center",
                      },
                    ]}
                    numberOfLines={2}
                    ellipsizeMode="tail"
                  >
                    {data?.esic_insurance_number
                      ? data?.esic_insurance_number
                      : "--"}
                  </Text>
                </View>
                <View
                  style={[
                    reportStyles.ReportTdCell,
                    {
                      width: "7%",
                      textAlign: "center",
                      borderRight: "  0.5px solid #ccc",
                    },
                  ]}
                >
                  <Text>{data?.uan_no ? data?.uan_no : "--"}</Text>
                </View>
                {/* <View
                  style={[
                    reportStyles.ReportTdCell,
                    {
                      width: "5%",
                      textAlign: "right",
                      borderRight: "  0.5px solid #ccc",
                    },
                  ]}
                >

                  <Text>----</Text>
                </View> */}
                
                <View
                  style={[
                    reportStyles.ReportTdCell,
                    {
                      width: "7%",
                      textAlign: "right",
                    },
                  ]}
                >
                  <Text>
                   ₹ {data?.salary_info?.gross_salary? formatIndianCurrency(data?.salary_info?.gross_salary.toFixed(2)) : 0.00}
                  </Text>
                </View>
                <View
                  style={[
                    reportStyles.ReportTdCell,
                    {
                      width: "4%",
                      borderRight: "  0.5px solid #ccc",
                      textAlign: "right",
                    },
                  ]}
                >
                  <Text>
                  ₹ {data?.benefits?.ot_rate? data?.benefits?.ot_rate.toFixed(2) : 0.00}
                  </Text>
                </View>

                {/* <View
                  style={[
                    reportStyles.ReportTdCell,
                    {
                      width: "5%",
                      textAlign: "right",
                      borderRight: "  0.5px solid #ccc",
                    },
                  ]}
                >
                  <Text>----</Text>
                </View> */}

                {/* <View
                  style={[
                    reportStyles.ReportTdCell,
                    {
                      width: "5%",
                      textAlign: "right",
                    },
                  ]}
                >
                  <Text>----</Text>
                </View> */}
              </View>
            </>
          ))}
        </View>
        <View style={reportStyles.footer} fixed>
          <Text>
            Download Time & date: {dayjs().format("DD-MM-YYYY hh:mm A")}{" "}
          </Text>
          <Text
            render={({ pageNumber, totalPages }) =>
              `${pageNumber} / ${totalPages}`
            }
          />
        </View>
      </Page>
    </Document>
  );
};

export default EmployeeExportPDF;
